import { isMobile } from './is-mobile'
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css/bundle';


/*
 * -----------------------------------------------
 */
const swiperSimple = document.querySelector('.swiper-simple');


if (swiperSimple && !isMobile()) {
  new Swiper(swiperSimple, {
    modules: [Navigation, Pagination, Autoplay],
    speed: 900,
    effect: 'slide',
    slidesPerView: 'auto',
    spaceBetween: 20,
    grabCursor: true,
    resistanceRatio: 0.6,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  });
}


/*
 * -----------------------------------------------
 */
const swiperNonstop = document.querySelector('.swiper-nonstop-slide');

if (swiperNonstop) {
  new Swiper(swiperNonstop, {
    modules: [Autoplay],
    observer: true,
    observeParents: true,
    slidesPerView: 'auto',
    centeredSlides: false,
    spaceBetween: 6,
    initialSlide: 1,
    loop: true,
    speed: 7500,
    allowTouchMove: false,
    autoplay: {
      enabled: true,
      delay: 1
    },
    breakpoints: {
      768: {
        spaceBetween: 10
      }
    }
  });
}
